var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer text-center"},[_vm._v("\n  © "+_vm._s((new Date()).getFullYear())+" TruVito    "),_c('i',{staticClass:"fas fa-globe text-light-green"})])}
var staticRenderFns = []

export { render, staticRenderFns }